import React from "react";
import Select from "react-select";

const SearchableCompanySelect = ({ companies, selectedDebtors, onChange, inputId, placeholder, noOptionsMessage }) => {
	const options = companies.map((company) => ({
		label: company.name,
		value: company.debiNr,
	}));
	const selectedOptions = options.filter((option) => selectedDebtors.includes(option.value));

	return (
		<Select
			inputId={inputId}
			className="account-company-select"
			classNamePrefix="account-company-select"
			isMulti
			isSearchable
			options={options}
			value={selectedOptions}
			onChange={(selected) => onChange((selected || []).map((option) => option.value))}
			placeholder={placeholder}
			noOptionsMessage={() => noOptionsMessage}
			closeMenuOnSelect={false}
			hideSelectedOptions={false}
			menuPlacement="auto"
		/>
	);
};

export default SearchableCompanySelect;